import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../constants/form'
import { QA_NAME_SAVE_BTN } from '../../../constants/qa'

export const REQUEST_EDIT_MANAGER_FIELD_NAME_ASSIGNEES = 'assignees'

export const REQUEST_EDIT_MANAGER_MODAL_QA_NAME = 'addManager'

export const REQUEST_EDIT_MANAGER_FORM_BODY_PROPS = {
  ...FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION,
  submitQaName: QA_NAME_SAVE_BTN,
  validationErrorsNotificationProps: {
    ...FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION.validationErrorsNotificationProps,
    responsibleManagersFieldName: REQUEST_EDIT_MANAGER_FIELD_NAME_ASSIGNEES,
  },
}

export const REQUEST_EDIT_MANAGER_MODAL_USERS_PARAMS = [
  ['with_field', 'role'],
  ['with_field', 'email'],
  ['with_field', 'avatar'],
  ['with_field', 'company_post_name'],
  ['role', 'manager'],
  ['role', 'admin'],
  ['archived', false],
]
